module.exports = __webpack_public_path__ + "media/images/size-guide-img2-4e98346afa36c12d792326617198b03a.png";